import { createElement, getUiRoot, setText } from './dom';

export function createConversationSurface(className: string) {
  const dialog = createElement('dialog', className, getUiRoot());
  dialog.setAttribute('role', 'dialog');
  dialog.setAttribute('aria-labelledby', `${className}-title`);
  const header = createElement('header', 'conversation-header', dialog);
  const identity = createElement('div', undefined, header);
  const role = createElement('p', 'conversation-role', identity);
  role.hidden = true;
  const title = createElement('h2', 'conversation-title', identity);
  title.id = `${className}-title`;
  const close = createElement('button', 'conversation-close', header);
  close.type = 'button';
  setText(close, 'Close');
  return { dialog, title, role, close };
}
